import { invoke } from '@tauri-apps/api/core';

import { GENIE_COMMAND_PREFIX as COMMAND_PREFIX, formatError } from './constants';

/**
 * Usual GP data from Genie
 */
export interface UsualGPData {
  gpId: number;
  title: string | null;
  lastName: string;
  firstName: string;
}

/**
 * Referrer data from Genie
 */
export interface ReferrerData {
  referrerId: number;
  title: string | null;
  lastName: string;
  firstName: string;
}

/**
 * PatientAppointmentData contains full patient appointment details on a specific day.
 */
export interface PatientAppointmentData {
  appointmentId: number;
  dateTime: string;
  patientId: number;
  lastName: string;
  firstName: string;
  middleName: string | null;
  prefix: string | null;
  dateOfBirth: string;
  medicareNumber: string | null;
  medicareReference: string | null;
  lastUpdated: string | null;
  lastSeen: string | null;
  practitionerId: number | null;
  usualGp: UsualGPData | null;
  referrers: ReferrerData[];
}

/**
 * Finds all patient appointments for a specific day.
 *
 * @param date - Date in format "YYYYMMDD"
 * @returns Array of patient appointments for the specified day
 * @throws Error if not connected or if the request fails
 */
export async function genieFindPatientAppointments(
  date: string
): Promise<PatientAppointmentData[]> {
  try {
    const appointments = await invoke<PatientAppointmentData[]>(
      `${COMMAND_PREFIX}find_patient_appointments`,
      {
        date,
      }
    );
    return appointments;
  } catch (error) {
    throw new Error(`Failed to find patient appointments: ${formatError(error)}`);
  }
}
